<template>
    <div>
        <div id="Loader">
            <div id="Loader_MainAnimation"></div>
            <div id="Loader_Title">Ładowanie...</div>
            <div id="Loader_Subtitle">
                <span>Zespół Szkół Elektronicznych</span>&nbsp;<span
                    >im. Wojska Polskiego w Bydgoszczy</span
                >
            </div>
        </div>
    </div>
</template>


<script>
import * as THREE from "three";
const MeshLine = require("three.meshline");

export default {
    name: "Loader",
    components: {},
    data: () => ({}),
    mounted: function () {
        // WebGL
        let container,
            camera,
            scene,
            renderer,
            light,
            resolution = new THREE.Vector2(
                window.innerWidth,
                window.innerHeight
            );

        // Animation
        let electrons = [],
            trails = [],
            cycles = 0,
            greyMat = new THREE.MeshPhongMaterial({
                color: new THREE.Color("#3D5AFE"),
                emissive: new THREE.Color("#3D5AFE"),
                specular: new THREE.Color("#3D5AFE"),
                flatShading: false,
                transparent: false,
                wireframe: false,
                opacity: 1,
            });

        init();
        animate();

        function init() {
            container = document.getElementById("Loader_MainAnimation");

            // RENDER SETUP
            renderer = new THREE.WebGLRenderer({ antialias: true });
            renderer.setClearColor(0xffffff);
            renderer.setPixelRatio(window.devicePixelRatio);
            renderer.setSize(window.innerWidth, window.innerHeight);
            container.appendChild(renderer.domElement);
            window.addEventListener(
                "resize",
                () => {
                    camera.aspect = window.innerWidth / window.innerHeight;
                    camera.updateProjectionMatrix();

                    renderer.setSize(window.innerWidth, window.innerHeight);
                },
                false
            );

            // CONFIG
            {
                // SCENE
                scene = new THREE.Scene();

                // CAMERA
                camera = new THREE.PerspectiveCamera(
                    75,
                    window.innerWidth / window.innerHeight,
                    1,
                    10000
                );
                camera.position.z = 2800; // 2800
                camera.position.y = 500; // 500

                // LIGHT
                light = new THREE.DirectionalLight(0xffffff, 0.8);
                light.position.y = 1000;
                light.position.x = 500;
                light.position.z = -100;
                light.lookAt(scene.position);

                // SKY
                const sky = new THREE.HemisphereLight(0xb1e1ff, 0x000033, 1);
                scene.add(sky);
            }

            // CENTER
            var sph = new THREE.SphereGeometry(100, 32, 16);
            sph.translate(0, 480, 0);
            let mesh = new THREE.Mesh(sph, greyMat);
            scene.add(mesh);

            // ELECTRONS
            const basePositions = [
                {
                    x: 550,
                    y: 530,
                    z: 0,
                },
                {
                    x: 2.523453508660168,
                    y: 122.63379804738292,
                    z: -328.0163862124218,
                },
                {
                    x: 225.89619450192197,
                    y: 291.9265817264288,
                    z: 454.64871341284083,
                },
            ];
            for (let j = 0; j < 3; j++) {
                let electron = new THREE.SphereGeometry(40, 32, 16);
                let electronGeo = new THREE.Mesh(electron, greyMat);

                electronGeo.translateY(500);
                electronGeo.position.set(
                    basePositions[j].x,
                    basePositions[j].y,
                    basePositions[j].z
                );

                scene.add(electronGeo);
                electrons.push(electronGeo);

                // TRAIL
                {
                    let trail_geometry = new THREE.Geometry();
                    for (var i = 0; i < 45; i++) {
                        trail_geometry.vertices.push(
                            electronGeo.position.clone()
                        );
                    }

                    // Create the line mesh
                    let trail_line = new MeshLine.MeshLine();
                    trail_line.setGeometry(trail_geometry, function (p) {
                        return p;
                    }); // makes width taper

                    // Create the line material
                    let trail_material = new MeshLine.MeshLineMaterial({
                        color: new THREE.Color("#42A5F5"),
                        opacity: 1,
                        resolution: resolution,
                        sizeAttenuation: 1,
                        lineWidth: 25,
                        depthTest: true,
                        blending: THREE.NormalBlending,
                        transparent: true,
                        side: THREE.DoubleSide,
                    });
                    let trail_mesh = new THREE.Mesh(
                        trail_line.geometry,
                        trail_material
                    );
                    trail_mesh.frustumCulled = false;

                    scene.add(trail_mesh);
                    trails.push(trail_line);
                }
            }
        }

        function animate() {
            requestAnimationFrame(animate);
            render();
            cycles++;
        }

        function render() {
            const q = 1;

            let sin = Math.sin((cycles / 7) * q);
            let cos = Math.cos((cycles / 7) * q);

            electrons[0].position.x = (550 * cos - 0 * sin) * q;
            electrons[0].position.z = (550 * sin + 0 * cos) * q;
            electrons[0].position.y = -180 * sin * q + 530;

            sin = Math.sin(((cycles + 27) / 7) * q);
            cos = Math.cos(((cycles + 27) / 7) * q);

            electrons[1].position.y = (500 * cos - 0 * sin) * q + 500;
            electrons[1].position.z = (500 * sin + 0 * cos) * q;
            electrons[1].position.x = (-200 * sin + 250 * cos + 60) * q;

            sin = Math.sin(((cycles + 14) / 7) * q);
            cos = Math.cos(((cycles + 14) / 7) * q);

            electrons[2].position.y = (500 * cos - 0 * sin) * q + 500;
            electrons[2].position.z = (500 * sin + 0 * cos) * q;
            electrons[2].position.x = (200 * sin + -250 * cos - 60) * q;

            trails[0].advance(electrons[0].position);
            trails[1].advance(electrons[1].position);
            trails[2].advance(electrons[2].position);

            renderer.render(scene, camera);
        }
    },
};
</script>

<style scoped>
#Loader {
    width: 100vw;
    height: 100vh;
    background-color: #fff;
    transition: all 1.5s cubic-bezier(0.17, 0.84, 0.44, 1);
    opacity: 1;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
}
#Loader.hide {
    opacity: 0;
    pointer-events: none;
}
#Loader_MainAnimation {
    transition: all 1.5s cubic-bezier(0.17, 0.84, 0.44, 1);
}
#Loader.hide #Loader_MainAnimation {
    transform: scale(0.9);
}
#Loader_Title {
    text-align: center;
    right: 0;
    left: 0;
    color: #42a5f5;
    font-size: 32px;
    top: 65%;
    position: absolute;
    z-index: 1;
    font-weight: 300;
}
#Loader_Subtitle {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 15px;
    height: auto;
    opacity: 0.7;
    font-size: 16px;
    color: #42a5f5;
    text-align: center;
}
#Loader_Subtitle > span {
    display: inline-block;
}
</style>